import { CustomerBO } from './PA.MD.BusinessObjects/CustomerBO'
import { MasterDataSetBO } from './PA.MD.BusinessObjects/MasterDataSetBO'
import { SalesOrgBO } from './PA.MD.BusinessObjects/SalesOrgBO'
import { SetBO } from './PA.MD.BusinessObjects/SetBO'
import { ApprovalBO } from './PA.MD.BusinessObjects/ApprovalBO'
import { CurrencyBO } from './PA.MD.BusinessObjects/CurrencyBO'
import { ExchangeRateBO } from './PA.MD.BusinessObjects/ExchangeRateBO'
import { SourceBO } from './PA.MD.BusinessObjects/SourceBO'
import { TagBO } from './PA.MD.BusinessObjects/TagBO'
import { TagSourceBO } from './PA.MD.BusinessObjects/TagSourceBO'
import { TagFunctionBO } from './PA.MD.BusinessObjects/TagFunctionBO'
import { TagRuleBO } from './PA.MD.BusinessObjects/TagRuleBO'
import { DomainBO } from './PA.MD.BusinessObjects/DomainBO'
import { ProductGroupBO } from './PA.MD.BusinessObjects/ProductGroupBO'
import { ProductBO } from './PA.MD.BusinessObjects/ProductBO'
import { PolicyBO } from './PA.MD.BusinessObjects/PolicyBO'
import { PolicyAreaBO } from './PA.MD.BusinessObjects/PolicyAreaBO'
import { PolicyCubeProcessBO } from './PA.MD.BusinessObjects/PolicyCubeProcessBO'
import { PricingEngineBO } from './PA.MD.BusinessObjects/PricingEngineBO'
import { MetaBO } from './PA.MD.BusinessObjects/MetaBO'
import { JobBO } from './PA.MD.BusinessObjects/JobBO'
import { NoteBO } from './PA.MD.BusinessObjects/NoteBO'
import { SnapshotBO } from './PA.MD.BusinessObjects/SnapshotBO'
import { SpendAllocationRuleBO } from './PA.MD.BusinessObjects/SpendAllocationRuleBO'
import { GeneralLedgerBO } from './PA.MD.BusinessObjects/GeneralLedgerBO'
import { GeneralLedgerAccountBO } from './PA.MD.BusinessObjects/GeneralLedgerAccountBO'
import { GeneralLedgerPolicyBO } from './PA.MD.BusinessObjects/GeneralLedgerPolicyBO'
import { FundTypeBO } from './PA.MD.BusinessObjects/FundTypeBO'
import { TransactionTypeBO } from './PA.MD.BusinessObjects/TransactionTypeBO'
import { TransactionBO } from './PA.MD.BusinessObjects/TransactionBO'
import { WorkflowBO } from './PA.MD.BusinessObjects/WorkflowBO'
import { BaseLnBO } from './PA.MD.BusinessObjects/BaseLnBO'
import { BaselineBO } from './PA.MD.BusinessObjects/BaselineBO'
import { PlanManagementBO } from './PA.MD.BusinessObjects/PlanManagementBO'
import { EventTypeBO } from './PA.MD.BusinessObjects/EventTypeBO'
import { PlanTypeBO } from './PA.MD.BusinessObjects/PlanTypeBO'
import { PaymentTypeBO } from './PA.MD.BusinessObjects/PaymentTypeBO'
import { PaymentBO } from './PA.Settlements.BusinessObjects/PaymentBO'
import { EventSpendTypeBO } from './PA.MD.BusinessObjects/EventSpendTypeBO'
import { PeriodBO } from './PA.MD.BusinessObjects/PeriodBO'
import { ProductConditionTypeBO } from './PA.MD.BusinessObjects/ProductConditionTypeBO'
import { ProductHierarchyBO } from './PA.MD.BusinessObjects/ProductHierarchyBO'
import { CustomerHierarchyBO } from './PA.MD.BusinessObjects/CustomerHierarchyBO'
import { CustomerTypeBO } from './PA.MD.BusinessObjects/CustomerTypeBO'
import { SourceCustomerTypeBO } from './PA.MD.BusinessObjects/SourceCustomerTypeBO'
import { ProductTypeBO } from './PA.MD.BusinessObjects/ProductTypeBO'
import { MetricDefinitionBO } from './PA.MD.BusinessObjects/MetricDefinition.BO'
import { MetricViewBO } from './PA.MD.BusinessObjects/MetricViewBO'
import { SnapshotTypeBO } from './PA.MD.BusinessObjects/SnapshotTypeBO'
import { ControlPointTypeBO } from './PA.MD.BusinessObjects/ControlPointTypeBO'
import { ControlPointBO } from './PA.MD.BusinessObjects/ControlPointBO'
import { LESpendBO } from './PA.MD.BusinessObjects/LESpendBO'
import { ActSpendBO } from './PA.MD.BusinessObjects/ActSpendBO'
import { ClassificationBO } from './PA.MD.BusinessObjects/ClassificationBO'
import { ClassificationControlBO } from './PA.MD.BusinessObjects/ClassificationControlBO'
import { JobProcessorBO } from './PA.Job.BusinessObjects/JobProcessorBO'
import { BusinessUnitBO } from './PA.MD.BusinessObjects/BusinessUnitBO'
import { ProductAttributeGroupBO } from './PA.MD.BusinessObjects/ProductAttributeGroupBO'
import { ProductAttributeMapBO } from './PA.MD.BusinessObjects/ProductAttributeMapBO'
import { PeriodHierarchyBO } from './PA.MD.BusinessObjects/PeriodHierarchyBO'
import { PeriodTypeBO } from './PA.MD.BusinessObjects/PeriodTypeBO'
import { CustomColumnBO } from './PA.MD.BusinessObjects/CustomColumnBO'
import { AffinitySetBO } from './PA.MD.BusinessObjects/AffinitySetBO'
import { PartitionBO } from './PA.MD.BusinessObjects/PartitionBO'
import { BenchmarkBO } from './PA.MD.BusinessObjects/BenchmarkBO'
import { UOMBO } from './PA.MD.BusinessObjects/UOMBO'
import { DataObjectBO } from './PA.MD.BusinessObjects/DataObjectBO'
import { CircularConfigBO } from './PA.MD.BusinessObjects/CircularConfigBO'
import { SourceTypeBO } from './PA.MD.BusinessObjects/SourceTypeBO'
import { SearchBO } from './PA.MD.BusinessObjects/SearchBO'
import { HierarchyBO } from './PA.MD.BusinessObjects/HierarchyBO'
import { PlanBO } from './PA.TPM.BusinessObjects/PlanBO'
import { EventBO } from './PA.TPM.BusinessObjects/EventBO'
import { TPMPlanBO } from './PA.TPM.BusinessObjects/TPMPlanBO'
import { TPMEventBO } from './PA.TPM.BusinessObjects/TPMEventBO'
import { ClaimTypeBO } from './PA.Settlements.BusinessObjects/ClaimTypeBO'
import { ClaimBO } from './PA.Settlements.BusinessObjects/ClaimBO'
import { UserBO } from './PA.Security.BusinessObjects/UserBO'
import { AuthProviderBO } from './PA.Security.BusinessObjects/AuthProviderBO'
import { UserGroupBO } from './PA.Security.BusinessObjects/UserGroupBO'
import { UserGroupTypeBO } from './PA.Security.BusinessObjects/UserGroupTypeBO'
import { UserGroupHierarchyBO } from './PA.Security.BusinessObjects/UserGroupHierarchyBO'
import { WorkspaceBO } from './PA.Reporting.BusinessObjects/WorkspaceBO'
import { ReportTileBO } from './PA.Reporting.BusinessObjects/ReportTileBO'
import { ConnectionBO } from './PA.Reporting.BusinessObjects/ConnectionBO'
import { DimensionBO } from './PA.Reporting.BusinessObjects/DimensionBO'
import { SubjectAreaBO } from './PA.Reporting.BusinessObjects/SubjectAreaBO'
import { ReportBO } from './PA.Reporting.BusinessObjects/ReportBO'
import { EventPortfolioBO } from './PA.Reporting.BusinessObjects/EventPortfolioBO'
import { CubeSourceBO } from './PA.Reporting.BusinessObjects/CubeSourceBO'
import { EDLPAnalysisBO } from './PA.Consumption.BusinessObjects/EDLPAnalysisBO'
import { CannibalizationSetBO } from './PA.Consumption.BusinessObjects/CannibalizationSetBO'
import { LoaderBO } from './PA.Loader.BusinessObjects/LoaderBO'
import { LoaderOperationBO } from './PA.Loader.BusinessObjects/LoaderOperationBO'
import { LoaderSourceBO } from './PA.Loader.BusinessObjects/LoaderSourceBO'
import { ModelPredictorBO } from './PA.Model.BusinessObjects/ModelPredictorBO'
import { ModelCannibalizationTypeBO } from './PA.Model.BusinessObjects/ModelCannibalizationTypeBO'
import { ModelFunctionBO } from './PA.Model.BusinessObjects/ModelFunctionBO'
import { ModelingSessionBO } from './PA.Model.BusinessObjects/ModelingSessionBO'
import { ModelBO } from './PA.Model.BusinessObjects/ModelBO'
import { ModelVolumeComponentBO } from './PA.Model.BusinessObjects/ModelVolumeComponentBO'
import { ModelCoefficientBO } from './PA.Model.BusinessObjects/ModelCoefficientBO'
import { ModelCoefficientSetBO } from './PA.Model.BusinessObjects/ModelCoefficientSetBO'
import { ModelInputBO } from './PA.Model.BusinessObjects/ModelInputBO'
import { ModelTermBO } from './PA.Model.BusinessObjects/ModelTermBO'
import { PublishedModelBO } from './PA.Model.BusinessObjects/PublishedModelBO'
import { ModelDataSourceBO } from './PA.Model.BusinessObjects/ModelDataSourceBO'
import { ModelPowerMetricBO } from './PA.Model.BusinessObjects/ModelPowerMetricBO'
import { ModelConstantBO } from './PA.Model.BusinessObjects/ModelConstantBO'
import { ModelCompareBO } from './PA.Model.BusinessObjects/ModelCompareBO'
import { SimulationInputBO } from './PA.Simulation.BusinessObjects/SimulationInputBO'
import { SimulationBO } from './PA.Simulation.BusinessObjects/SimulationBO'
import { ConstraintBasedOptimizerBO } from './PA.Simulation.BusinessObjects/ConstraintBasedOptimizerBO'
import { SpendFunctionBO } from './PA.Simulation.BusinessObjects/SpendFunctionBO'
import { UIProfileBO } from './PA.UIFramework.BusinessObject/UIProfileBO'
import { UIAppSuiteTypeBO } from './PA.UIFramework.BusinessObject/UIAppSuiteTypeBO'
import { UIAppSuiteBO } from './PA.UIFramework.BusinessObject/UIAppSuiteBO'
import { UIAppExecutableBO } from './PA.UIFramework.BusinessObject/UIAppExecutableBO'
import { UIApplicationBO } from './PA.UIFramework.BusinessObject/UIApplicationBO'
import { SnapshotParameterBO } from './PA.MD.BusinessObjects/SnapshotParameterBO'
import { ModelScorecardBO } from './PA.Model.BusinessObjects/ModelScorecardBO'
import { GLTransactionBO } from './PA.MD.BusinessObjects/GLTransactionBO'
import { BatchScopeBO } from './PA.MD.BusinessObjects/BatchScopeBO'
import { BatchProcessBO } from './PA.MD.BusinessObjects/BatchProcessBO'
import { EventVolumeBO } from './PA.MD.BusinessObjects/EventVolumeBO'
import { DataMartBO } from './PA.MD.BusinessObjects/DataMartBO'
import { DeconstructedDataMartBO } from './PA.MD.BusinessObjects/DeconstructedDataMartBO'
import { ScenarioPlanBO } from './PA.Simulation.BusinessObjects/ScenarioPlanBO'
import { SimulationCompareBO } from './PA.Simulation.BusinessObjects/SimulationCompareBO'
import { PEAEventOverrideBO } from './PA.TPM.BusinessObjects/PEAEventOverrideBO'
import { VolDecompBO } from './PA.MD.BusinessObjects/VolDecompBO'
import { ScenarioPlanCompareBO } from './PA.Simulation.BusinessObjects/ScenarioPlanCompareBO'
import { PPAScenarioBO } from './PA.PPA.BusinessObjects/PPAScenarioBO'
import { PPAProductBO } from './PA.PPA.BusinessObjects/PPAProductBO'
import { PPAModelBO } from './PA.PPA.BusinessObjects/PPAModelBO'
import { ScenarioPlannerBO } from './PA.Simulation.BusinessObjects/ScenarioPlannerBO'
import { ConsumptionOverrideBO } from './PA.FC.Core/ConsumptionOverrideBO'
import { FundingRuleBO } from "./PA.MD.BusinessObjects/FundingRuleBO"

const MdlBO = {
    BO: {
        MD: {
            Customer: CustomerBO,
            MasterDataSet: MasterDataSetBO,
            SalesOrg: SalesOrgBO,
            Set: SetBO,
            Approval: ApprovalBO,
            Currency: CurrencyBO,
            ExchangeRateTye: ExchangeRateBO,
            Source: SourceBO,
            Tag: TagBO,
            TagSource: TagSourceBO,
            TagFunction: TagFunctionBO,
            TagRule: TagRuleBO,
            Domain: DomainBO,
            ProductGroup: ProductGroupBO,
            Product: ProductBO,
            Policy: PolicyBO,
            PolicyArea: PolicyAreaBO,
            PolicyCubeProcess: PolicyCubeProcessBO,
            BatchScope: BatchScopeBO,
            PricingEngine: PricingEngineBO,
            Meta: MetaBO,
            Job: JobBO,
            FinishedProduct: ProductBO,
            Note: NoteBO,
            Snapshot: SnapshotBO,
            SnapshotParameter: SnapshotParameterBO,
            SpendAllocationRule: SpendAllocationRuleBO,
            GeneralLedger: GeneralLedgerBO,
            GeneralLedgerAccount: GeneralLedgerAccountBO,
            GeneralLedgerPolicy: GeneralLedgerPolicyBO,
            FundType: FundTypeBO,
            TransactionType: TransactionTypeBO,
            Transaction: TransactionBO,
            GLTransaction: GLTransactionBO,
            Workflow: WorkflowBO,
            BaseLn: BaseLnBO,
            Baseline: BaselineBO,
            PlanManagement: PlanManagementBO,
            EventType: EventTypeBO,
            PlanType: PlanTypeBO,
            PaymentType: PaymentTypeBO,
            Payment: PaymentBO,
            EventSpendType: EventSpendTypeBO,
            Period: PeriodBO,
            ProductConditionType: ProductConditionTypeBO,
            ProductHierarchy: ProductHierarchyBO,
            CustomerHierarchy: CustomerHierarchyBO,
            CustomerType: CustomerTypeBO,
            DataMart: DataMartBO,
            SourceCustomerTypeBO: SourceCustomerTypeBO,
            ProductType: ProductTypeBO,
            MetricDefinition: MetricDefinitionBO,
            MetricView: MetricViewBO,
            SnapshotType: SnapshotTypeBO,
            ControlPointType: ControlPointTypeBO,
            ControlPoint: ControlPointBO,
            BatchProcessBO: BatchProcessBO,
            LESpend: LESpendBO,
            ActSpend: ActSpendBO,
            EventVolume: EventVolumeBO,
            Classification: ClassificationBO,
            ClassificationControl: ClassificationControlBO,
            JobProcessor: JobProcessorBO,
            BusinessUnit: BusinessUnitBO,
            ProductAttributeGroup: ProductAttributeGroupBO,
            ProductAttributeMap: ProductAttributeMapBO,
            PeriodHierarchy: PeriodHierarchyBO,
            PeriodType: PeriodTypeBO,
            CustomColumn: CustomColumnBO,
            AffinitySet: AffinitySetBO,
            Partition: PartitionBO,
            Benchmark: BenchmarkBO,
            UOM: UOMBO,
            DataObject: DataObjectBO,
            CircularConfig: CircularConfigBO,
            SourceType: SourceTypeBO,
            Search: SearchBO,
            HierarchyBO: HierarchyBO,
            VolDecompBO: VolDecompBO,
            DeconstructedDataMartBO: DeconstructedDataMartBO,
            FundingRuleBO:FundingRuleBO
        },
        TPM: {
            Plan: PlanBO,
            Event: EventBO,
            TPMPlan: TPMPlanBO,
            TPMEventBO: TPMEventBO,
            EventOverride: PEAEventOverrideBO,
            ConsumptionOverride: ConsumptionOverrideBO
        },
        Settlements: {
            ClaimType: ClaimTypeBO,
            Claim: ClaimBO
        },
        Security: {
            User: UserBO,
            AuthProvider: AuthProviderBO,
            UserGroup: UserGroupBO,
            UserGroupType: UserGroupTypeBO,
            UserGroupHierarchy: UserGroupHierarchyBO
        },
        Reporting: {
            Workspace: WorkspaceBO,
            ReportTile: ReportTileBO,
            Connection: ConnectionBO,
            Dimension: DimensionBO,
            SubjectArea: SubjectAreaBO,
            Report: ReportBO,
            EventPortfolio: EventPortfolioBO,
            CubeSource: CubeSourceBO
        },
        Consumption: {
            EDLPAnalysis: EDLPAnalysisBO,
            CannibalizationSet: CannibalizationSetBO
        },
        Loader: {
            Loader: LoaderBO,
            LoaderOperation: LoaderOperationBO,
            LoaderSource: LoaderSourceBO
        },
        Model: {
            ModelPredictor: ModelPredictorBO,
            ModelCannibalizationType: ModelCannibalizationTypeBO,
            ModelFunction: ModelFunctionBO,
            ModelingSession: ModelingSessionBO,
            Model: ModelBO,
            ModelVolumeComponent: ModelVolumeComponentBO,
            ModelCoefficient: ModelCoefficientBO,
            ModelCoefficientSet: ModelCoefficientSetBO,
            ModelInput: ModelInputBO,
            ModelTerm: ModelTermBO,
            PublishedModelBO: PublishedModelBO,
            ModelDataSource: ModelDataSourceBO,
            ModelPowerMetric: ModelPowerMetricBO,
            ModelConstant: ModelConstantBO,
            ModelCompare: ModelCompareBO,
            ModelScorecard: ModelScorecardBO
        },
        PPA: {
            PPAModelBO:PPAModelBO,
            PPAScenarioBO: PPAScenarioBO,
            PPAProductBO: PPAProductBO
        },
        Simulation: {
            SimulationInput: SimulationInputBO,
            Simulation: SimulationBO,
            SimulationCompare: SimulationCompareBO,
            CBO: ConstraintBasedOptimizerBO,
            SpendFunction: SpendFunctionBO,
            ScenarioPlan: ScenarioPlanBO,
            ScenarioPlanCompare: ScenarioPlanCompareBO,
            ScenarioPlanner: ScenarioPlannerBO,
        },
        UIFramework: {
            UIProfile: UIProfileBO,
            UIAppSuiteType: UIAppSuiteTypeBO,
            UIAppSuite: UIAppSuiteBO,
            UIAppExec: UIAppExecutableBO,
            UIApplication: UIApplicationBO
        }
    }
};

export { MdlBO };
